export const GET_APPLICANT_REQUEST="GET_APPLICANT_REQUEST"
export const GET_APPLICANT_SUCCESS="GET_APPLICANT_SUCCESS"
export const GET_APPLICANT_FAILURE="GET_APPLICANT_FAILURE"



export const GET_TODO_REQUEST="GET_TODO_REQUEST"
export const GET_TODO_FAILURE="GET_TODO_FAILURE"
export const GET_TODO_SUCCESS="GET_TODO_SUCCESS "

